var map = {
	"./buoy_logo.svg": 866,
	"./buoy_logo_inverse.svg": 867,
	"./demo_logo.svg": 868,
	"./fhstaff_logo.svg": 869,
	"./fhstaff_logo_inverse.svg": 870,
	"./froedtert_logo.svg": 871,
	"./froedtert_logo_inverse.svg": 872,
	"./hphc-hpl_logo.svg": 873,
	"./hphc_logo.svg": 874,
	"./novartis_logo.svg": 875,
	"./novartis_logo_inverse.svg": 876,
	"./nyt_logo.svg": 877,
	"./rcw_logo.svg": 878,
	"./steward_logo.svg": 879,
	"./steward_logo_inverse.svg": 880,
	"./uhhospitals_logo.svg": 881,
	"./uhhospitals_logo_inverse.svg": 882
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 398;



//////////////////
// WEBPACK FOOTER
// ./~/buoy-config/dist/images nonrecursive \.(png|jpe?g|svg)$
// module id = 398
// module chunks = 168707334958949